import { render, staticRenderFns } from "./FinanceQA.vue?vue&type=template&id=bf18b29e&scoped=true&"
import script from "./FinanceQA.vue?vue&type=script&lang=js&"
export * from "./FinanceQA.vue?vue&type=script&lang=js&"
import style0 from "./FinanceQA.vue?vue&type=style&index=0&id=bf18b29e&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bf18b29e",
  null
  
)

export default component.exports